"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRpcProvider = exports.getUtxoProvider = exports.Types = void 0;
const OrdinalProviders = __importStar(require("./ordinal"));
const ApiProviders = __importStar(require("./api"));
const UtxoProviders = __importStar(require("./utxo"));
const rpc_1 = require("./rpc");
const teleportdao_1 = require("../teleportdao");
__exportStar(require("./ordinal"), exports);
__exportStar(require("./api"), exports);
__exportStar(require("./utxo"), exports);
__exportStar(require("./rpc"), exports);
exports.Types = __importStar(require("./types"));
function getUtxoProvider(connectionInfo, networkName) {
    let testnet = !!(networkName === null || networkName === void 0 ? void 0 : networkName.includes("_testnet"));
    if (connectionInfo.provider === "TeleportDao") {
        return new teleportdao_1.TeleportDao(testnet);
    }
    if (connectionInfo.provider === "BlockStream" || connectionInfo.provider === "MempoolSpace") {
        return new ApiProviders[connectionInfo.provider](testnet);
    }
    if (connectionInfo.provider === "NowNodes") {
        if (!connectionInfo.token)
            throw new Error("Provider Needs Token");
        return new UtxoProviders.NowNodes({ token: connectionInfo.token }, testnet);
    }
    if (connectionInfo.provider === "Unisat") {
        if (!connectionInfo.token)
            throw new Error("Provider Needs Token");
        return new OrdinalProviders.UniSat({ token: connectionInfo.token }, testnet);
    }
    throw new Error("provider not supported");
}
exports.getUtxoProvider = getUtxoProvider;
function getRpcProvider(connectionInfo) {
    return new rpc_1.BitcoinRPC(connectionInfo);
}
exports.getRpcProvider = getRpcProvider;
//# sourceMappingURL=index.js.map